export enum SessionStorageKeys {
    mvcSessionId = "_mvcSessionId",
    invalidSessionMvc = "invalid_session_",
}
